var _path, _path2, _path3, _path4, _ellipse, _ellipse2, _rect, _rect2, _ellipse3, _ellipse4, _path5, _path6, _g, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _circle, _path22, _circle2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemoteAccessNoKeys(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 170,
    height: 180,
    viewBox: "0 0 170 180",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.9591 152.918C114.529 152.918 147.418 120.029 147.418 79.4586C147.418 38.8883 114.529 5.99951 73.9591 5.99951C33.3888 5.99951 0.5 38.8883 0.5 79.4586C0.5 120.029 33.3888 152.918 73.9591 152.918Z",
    fill: "url(#paint0_linear_1158_1007)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5154 75.677C24.291 66.1906 32.7277 58.8255 43.4661 58.2222C49.8879 57.8613 57.7401 57.5776 66.5552 57.5776C75.3703 57.5776 83.2225 57.8613 89.6444 58.2222C100.383 58.8255 108.819 66.1906 109.595 75.6769C109.908 79.5057 110.133 83.6212 110.133 87.5376C110.133 91.454 109.908 95.5695 109.595 99.3983C108.819 108.885 100.383 116.25 89.6444 116.853C83.2225 117.214 75.3703 117.498 66.5552 117.498C57.7401 117.498 49.8879 117.214 43.4661 116.853C32.7277 116.25 24.291 108.885 23.5154 99.3983C23.2023 95.5695 22.9771 91.454 22.9771 87.5376C22.9771 83.6212 23.2023 79.5057 23.5154 75.677ZM76.2393 83.2576C76.2393 86.426 74.2918 89.1924 71.3972 90.6724V96.0976C71.3972 98.4614 69.2294 100.378 66.5552 100.378C63.881 100.378 61.7132 98.4614 61.7132 96.0976V90.6724C58.8186 89.1924 56.8712 86.426 56.8712 83.2576C56.8712 78.5301 61.2069 74.6976 66.5552 74.6976C71.9036 74.6976 76.2393 78.5301 76.2393 83.2576Z",
    fill: "#4B4B4B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4395 77.2197C23.2345 66.3535 31.8821 57.9172 42.8889 57.2261C49.4713 56.8128 57.5198 56.4878 66.5553 56.4878C75.5908 56.4878 83.6393 56.8128 90.2217 57.2261C101.229 57.9172 109.876 66.3535 110.671 77.2197C110.992 81.6054 111.223 86.3195 111.223 90.8056C111.223 95.2917 110.992 100.006 110.671 104.391C109.876 115.258 101.229 123.694 90.2217 124.385C83.6393 124.798 75.5908 125.123 66.5553 125.123C57.5198 125.123 49.4713 124.798 42.8889 124.385C31.8821 123.694 23.2345 115.258 22.4395 104.391C22.1186 100.006 21.8877 95.2917 21.8877 90.8056C21.8877 86.3195 22.1186 81.6054 22.4395 77.2197ZM76.4814 85.9031C76.4814 89.5323 74.4853 92.701 71.5184 94.3964V100.611C71.5184 103.318 69.2963 105.513 66.5553 105.513C63.8143 105.513 61.5922 103.318 61.5922 100.611V94.3964C58.6253 92.701 56.6292 89.5323 56.6292 85.9031C56.6292 80.4879 61.0733 76.098 66.5553 76.098C72.0374 76.098 76.4814 80.4879 76.4814 85.9031Z",
    fill: "url(#paint1_linear_1158_1007)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.81 115.615C108.036 97.1993 107.829 71.4113 100.062 69.5619C89.2961 66.9986 36.074 64.9178 23.4863 72.8545C25.9557 64.1632 33.6861 57.8214 43.167 57.2261C49.7493 56.8128 57.7979 56.4878 66.8333 56.4878C75.8688 56.4878 83.9173 56.8128 90.4997 57.2261C101.507 57.9172 110.154 66.3535 110.949 77.2197C111.27 81.6054 111.501 86.3195 111.501 90.8056C111.501 95.2917 111.27 100.006 110.949 104.391C110.641 108.6 109.155 112.444 106.81 115.615Z",
    fill: "#D9D9D9"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.5787,
    cy: 61.3903,
    rx: 9.26036,
    ry: 4.90254,
    fill: "#969696"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 84.5309,
    cy: 61.3903,
    rx: 9.26036,
    ry: 4.90254,
    fill: "#969696"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 39.3184,
    y: 57.5776,
    width: 18.5207,
    height: 3.26836,
    fill: "#969696"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 75.2705,
    y: 57.5776,
    width: 18.5207,
    height: 3.26836,
    fill: "#969696"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.5787,
    cy: 57.5776,
    rx: 9.26036,
    ry: 5.44727,
    fill: "url(#paint2_linear_1158_1007)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 84.5304,
    cy: 57.5776,
    rx: 9.26036,
    ry: 5.44727,
    fill: "url(#paint3_linear_1158_1007)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.9443 37.9683C46.9443 25.9345 55.7241 16.1792 66.5545 16.1792C77.3849 16.1792 86.1647 25.9345 86.1647 37.9683V55.3996C86.1647 57.8063 84.4087 59.7574 82.2427 59.7574C80.0766 59.7574 78.3206 57.8063 78.3206 55.3996V37.9683C78.3206 30.748 73.0528 24.8948 66.5545 24.8948C60.0563 24.8948 54.7884 30.748 54.7884 37.9683V55.3996C54.7884 57.8063 53.0325 59.7574 50.8664 59.7574C48.7003 59.7574 46.9443 57.8063 46.9443 55.3996V37.9683Z",
    fill: "url(#paint4_linear_1158_1007)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.6768 36.878C43.6768 24.2426 53.9198 13.9995 66.5553 13.9995C79.1908 13.9995 89.4338 24.2426 89.4338 36.878V55.1809C89.4338 57.708 87.3852 59.7566 84.8581 59.7566C82.331 59.7566 80.2824 57.708 80.2824 55.1809V36.878C80.2824 29.2968 74.1366 23.1509 66.5553 23.1509C58.974 23.1509 52.8282 29.2968 52.8282 36.878V55.1809C52.8282 57.708 50.7796 59.7566 48.2525 59.7566C45.7254 59.7566 43.6768 57.708 43.6768 55.1809V36.878Z",
    fill: "#DCDCDC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1158_1007)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.812 147C132.657 147 147.123 132.673 147.123 115C147.123 97.3264 132.657 82.9995 114.812 82.9995C96.9664 82.9995 82.5 97.3264 82.5 115C82.5 132.673 96.9664 147 114.812 147Z",
    fill: "url(#paint5_linear_1158_1007)"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M114.811 142.22C129.96 142.22 142.24 130.033 142.24 115C142.24 99.966 129.96 87.7788 114.811 87.7788C99.663 87.7788 87.3828 99.966 87.3828 115C87.3828 130.033 99.663 142.22 114.811 142.22Z",
    fill: "url(#paint6_linear_1158_1007)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M142.344 114.896C142.344 115.415 142.344 115.831 142.24 116.35C141.513 102.013 129.565 90.584 114.915 90.584C100.266 90.584 88.3179 102.013 87.4867 116.35C87.4867 115.831 87.3828 115.415 87.3828 114.896C87.3828 99.9347 99.7464 87.7788 114.811 87.7788C130.084 87.7788 142.344 99.9347 142.344 114.896Z",
    fill: "#D2DFF8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M114.189 113.648L112.111 115.726L99.2283 103.051C98.6049 102.427 98.6049 101.492 99.2283 100.973C99.8517 100.35 100.787 100.35 101.306 100.973L114.189 113.648Z",
    fill: "url(#paint7_linear_1158_1007)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M117.409 115.832L115.331 113.754L124.889 104.299C125.513 103.676 126.448 103.676 126.967 104.299C127.591 104.922 127.591 105.858 126.967 106.377L117.409 115.832Z",
    fill: "url(#paint8_linear_1158_1007)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M113.565 114.584C114.396 113.753 115.539 113.753 116.266 114.584C117.097 115.415 117.097 116.558 116.266 117.181C115.435 117.805 114.292 118.012 113.565 117.181C112.838 116.454 112.838 115.311 113.565 114.584Z",
    fill: "#AAB2C5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M121.669 136.715C121.461 136.715 121.254 136.611 121.254 136.403L114.5 116.039C114.396 115.831 114.604 115.52 114.812 115.416C115.02 115.312 115.331 115.52 115.435 115.728L122.189 136.091C122.292 136.299 122.085 136.611 121.877 136.715C121.773 136.715 121.773 136.715 121.669 136.715Z",
    fill: "url(#paint9_linear_1158_1007)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M112.63 113.649C113.981 112.403 116.059 112.403 117.306 113.649C118.656 114.896 118.656 116.974 117.306 118.325C115.955 119.675 113.877 119.571 112.63 118.325C111.383 117.078 111.28 114.896 112.63 113.649Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.027 114.98L116.001 114.954C115.502 114.455 114.555 114.383 113.881 115.005C113.39 115.458 113.339 116.425 113.934 117.021C114.499 117.585 115.409 117.613 116.001 117.021C116.662 116.36 116.584 115.493 116.055 115.005L116.027 114.98ZM117.306 113.649C116.059 112.403 113.981 112.403 112.63 113.649C111.28 114.896 111.383 117.078 112.63 118.325C113.877 119.571 115.955 119.675 117.306 118.325C118.656 116.974 118.656 114.896 117.306 113.649Z",
    fill: "url(#paint10_linear_1158_1007)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M115.851 90.2729H114.189C113.877 90.2729 113.565 90.5846 113.565 90.8963V95.7794C113.565 96.0911 113.877 96.4028 114.189 96.4028H115.851C116.163 96.4028 116.475 96.0911 116.475 95.7794V90.7924C116.371 90.4807 116.163 90.2729 115.851 90.2729Z",
    fill: "url(#paint11_linear_1158_1007)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M115.851 133.39H114.189C113.877 133.39 113.565 133.702 113.565 134.014V138.897C113.565 139.208 113.877 139.52 114.189 139.52H115.851C116.163 139.52 116.475 139.208 116.475 138.897V134.014C116.371 133.702 116.163 133.39 115.851 133.39Z",
    fill: "url(#paint12_linear_1158_1007)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5905 113.337H90.7074C90.3957 113.337 90.084 113.649 90.084 113.961V115.623C90.084 115.935 90.3957 116.246 90.7074 116.246H95.5905C95.9022 116.246 96.2139 115.935 96.2139 115.623V113.961C96.2139 113.649 95.9022 113.337 95.5905 113.337Z",
    fill: "url(#paint13_linear_1158_1007)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M139.227 113.441H134.344C134.032 113.441 133.721 113.753 133.721 114.064V115.727C133.721 116.038 134.032 116.35 134.344 116.35H139.227C139.539 116.35 139.851 116.038 139.851 115.727V114.064C139.747 113.753 139.539 113.441 139.227 113.441Z",
    fill: "url(#paint14_linear_1158_1007)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M136.795 59.5095C136.329 57.5799 133.584 57.5799 133.119 59.5095L132.846 60.6401C132.642 61.4829 131.984 62.1409 131.141 62.3444L130.011 62.6173C128.081 63.0831 128.081 65.8277 130.011 66.2935L131.141 66.5664C131.984 66.7699 132.642 67.4279 132.846 68.2707L133.119 69.4013C133.584 71.3309 136.329 71.3309 136.795 69.4013L137.068 68.2707C137.271 67.4279 137.929 66.7699 138.772 66.5664L139.903 66.2935C141.832 65.8277 141.832 63.0831 139.903 62.6173L138.772 62.3444C137.929 62.1409 137.271 61.4829 137.068 60.6401L136.795 59.5095Z",
    fill: "#385BF8",
    stroke: "#385BF8",
    strokeWidth: 0.420208
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7948 132.51C65.329 130.58 62.5844 130.58 62.1186 132.51L61.8457 133.64C61.6422 134.483 60.9842 135.141 60.1414 135.344L59.0109 135.617C57.0812 136.083 57.0812 138.828 59.0109 139.294L60.1414 139.566C60.9842 139.77 61.6422 140.428 61.8457 141.271L62.1186 142.401C62.5844 144.331 65.329 144.331 65.7948 142.401L66.0677 141.271C66.2712 140.428 66.9292 139.77 67.772 139.566L68.9026 139.294C70.8322 138.828 70.8322 136.083 68.9026 135.617L67.772 135.344C66.9292 135.141 66.2712 134.483 66.0677 133.64L65.7948 132.51Z",
    fill: "#385BF8",
    stroke: "#385BF8",
    strokeWidth: 0.420208
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7953 41.5095C15.3295 39.5799 12.5849 39.5799 12.1191 41.5095L11.8462 42.6401C11.6427 43.4829 10.9847 44.1409 10.1419 44.3444L9.01134 44.6173C7.08172 45.0831 7.08172 47.8277 9.01134 48.2935L10.1419 48.5664C10.9847 48.7699 11.6427 49.4279 11.8462 50.2707L12.1191 51.4013C12.5849 53.3309 15.3295 53.3309 15.7953 51.4013L16.0682 50.2707C16.2717 49.4279 16.9297 48.7699 17.7725 48.5664L18.9031 48.2935C20.8327 47.8277 20.8327 45.0831 18.9031 44.6173L17.7725 44.3444C16.9297 44.1409 16.2717 43.4829 16.0682 42.6401L15.7953 41.5095Z",
    fill: "#385BF8",
    stroke: "#385BF8",
    strokeWidth: 0.420208
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.92463,
    cy: 3.92463,
    r: 2.61149,
    transform: "matrix(-1 0 0 1 110.35 24.9995)",
    stroke: "#385BF8",
    strokeWidth: 2.6263
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5381 7.00831C48.3548 6.41267 48.2205 5.15626 47.2963 4.74676L43.9631 3.26987C43.0388 2.86038 42.0179 3.60492 42.1254 4.61005L42.513 8.23517C42.6205 9.2403 43.7757 9.75217 44.5925 9.15654L47.5381 7.00831Z",
    fill: "#385BF8",
    stroke: "#385BF8",
    strokeWidth: 0.875432
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.92463,
    cy: 3.92463,
    r: 2.61149,
    transform: "matrix(-1 0 0 1 8.3501 124)",
    stroke: "#385BF8",
    strokeWidth: 2.6263
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1158_1007",
    x: 60.5,
    y: 71.9995,
    width: 108.624,
    height: 108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1158_1007"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1158_1007",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1158_1007",
    x1: 73.3929,
    y1: -17.9206,
    x2: 74.8977,
    y2: 240.057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCDCDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1158_1007",
    x1: 25.79,
    y1: 216.351,
    x2: 115.832,
    y2: 214.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#747474"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1158_1007",
    x1: 44.4266,
    y1: 58.1456,
    x2: 53.7488,
    y2: 61.7575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9A9A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2D2D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1158_1007",
    x1: 80.3783,
    y1: 58.1456,
    x2: 89.7005,
    y2: 61.7575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9A9A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2D2D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1158_1007",
    x1: 57.7619,
    y1: 40.2403,
    x2: 79.5497,
    y2: 44.7093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9A9A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2D2D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1158_1007",
    x1: 85.3228,
    y1: 232.066,
    x2: 150.469,
    y2: 231.005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#747474"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1158_1007",
    x1: 85.7357,
    y1: 128.603,
    x2: 190.316,
    y2: 140.137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1158_1007",
    x1: 99.4347,
    y1: 135.957,
    x2: 114.988,
    y2: 135.703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#747474"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1158_1007",
    x1: 115.86,
    y1: 131.782,
    x2: 128.062,
    y2: 131.583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#747474"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1158_1007",
    x1: 114.811,
    y1: 165.061,
    x2: 122.619,
    y2: 165.015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#747474"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1158_1007",
    x1: 111.947,
    y1: 128.051,
    x2: 118.663,
    y2: 127.942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#747474"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1158_1007",
    x1: 113.693,
    y1: 104.55,
    x2: 116.626,
    y2: 104.528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#747474"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1158_1007",
    x1: 113.693,
    y1: 147.668,
    x2: 116.626,
    y2: 147.645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#747474"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1158_1007",
    x1: 90.3517,
    y1: 120.113,
    x2: 96.5257,
    y2: 119.903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#747474"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1158_1007",
    x1: 133.988,
    y1: 120.217,
    x2: 140.162,
    y2: 120.007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#747474"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoteAccessNoKeys);
export default __webpack_public_path__ + "static/media/remote-access-no-keys.f3c2d17903b264e063a754147407248b.svg";
export { ForwardRef as ReactComponent };